<template>
  <div>
    <Modal title="网络资源配额" v-model="networkQuotaModal" width="800">
      <Alert show-icon type="error" v-if="networkQuotaError">{{ networkQuotaErrorMsg }}</Alert>
      <Spin fix v-if="networkQuotaLoading">
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      </Spin>
      <Spin fix v-else-if="networkQuotaGetError">
        <Alert show-icon type="error">获取数据失败</Alert>
      </Spin>
      <div v-else>
        <Alert show-icon>
          <span>填 -1 表示不限制</span>
        </Alert>
        <Form ref="networkQuotaForm" :model="networkQuotaForm" :rules="networkQuotaRules" :label-width="100">
          <FormItem prop="floatingip" label="浮动IP">
            <InputNumber v-model="networkQuotaForm.floatingip" style="width: 300px" :min="-1"/>
            <span style="text-align: right; margin-left: 20px" v-if="networkQuota.floatingip">
              <span style="color: #19be6b">已用：{{ networkQuota.floatingip.used }}</span>
            </span>
          </FormItem>
          <FormItem prop="network" label="虚拟网络">
            <InputNumber v-model="networkQuotaForm.network" style="width: 300px" :min="-1"/>
            <span style="text-align: right; margin-left: 20px" v-if="networkQuota.network">
              <span style="color: #19be6b">已用：{{ networkQuota.network.used }}</span>
            </span>
          </FormItem>
          <FormItem prop="subnet" label="子网">
            <InputNumber v-model="networkQuotaForm.subnet" style="width: 300px" :min="-1"/>
            <span style="text-align: right; margin-left: 20px" v-if="networkQuota.subnet">
              <span style="color: #19be6b">已用：{{ networkQuota.subnet.used }}</span>
            </span>
          </FormItem>
          <FormItem prop="port" label="端口">
            <InputNumber v-model="networkQuotaForm.port" style="width: 300px" :min="-1"/>
            <span style="text-align: right; margin-left: 20px" v-if="networkQuota.port">
              <span style="color: #19be6b">已用：{{ networkQuota.port.used }}</span>
            </span>
          </FormItem>
          <FormItem prop="router" label="路由">
            <InputNumber v-model="networkQuotaForm.router" style="width: 300px" :min="-1"/>
            <span style="text-align: right; margin-left: 20px" v-if="networkQuota.router">
              <span style="color: #19be6b">已用：{{ networkQuota.router.used }}</span>
            </span>
          </FormItem>
          <FormItem prop="security_group" label="安全组">
            <InputNumber v-model="networkQuotaForm.security_group" style="width: 300px" :min="-1"/>
            <span style="text-align: right; margin-left: 20px" v-if="networkQuota.security_group">
              <span style="color: #19be6b">已用：{{ networkQuota.security_group.used }}</span>
            </span>
          </FormItem>
          <FormItem prop="security_group_rule" label="安全组规则">
            <InputNumber v-model="networkQuotaForm.security_group_rule" style="width: 300px" :min="-1"/>
            <span style="text-align: right; margin-left: 20px" v-if="networkQuota.security_group_rule">
              <span style="color: #19be6b">已用：{{ networkQuota.security_group_rule.used }}</span>
            </span>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button type="primary" style="margin-right: 8px" @click="networkQuotaSubmit" :loading="networkQuotaSubmitting">修改</Button>
        <Button @click="networkQuotaModal = false">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getPrivateCloudNetworkQuota, updatePrivateCloudNetworkQuota } from '@/api/private-cloud/quota-network'

export default {
  name: 'network-quota',
  data () {
    return {
      project: {},
      networkQuotaModal: false,
      networkQuotaSubmitting: false,
      networkQuotaLoading: false,
      networkQuotaGetError: false,
      networkQuotaError: false,
      networkQuotaErrorMsg: null,
      networkQuota: {},
      networkQuotaForm: {
        floatingip: null,
        network: null,
        subnet: null,
        port: null,
        router: null,
        security_group: null,
        security_group_rule: null
      },
      networkQuotaRules: {
        floatingip: { required: true, message: '浮动IP数量是必填的', type: 'number', trigger: 'blur' },
        network: { required: true, message: '虚拟网络数量是必填的', type: 'number', trigger: 'blur' },
        subnet: { required: true, message: '子网数量是必填的', type: 'number', trigger: 'blur' },
        port: { required: true, message: '端口数量是必填的', type: 'number', trigger: 'blur' },
        router: { required: true, message: '虚拟路由数量是必填的', type: 'number', trigger: 'blur' },
        security_group: { required: true, message: '安全组数量是必填的', type: 'number', trigger: 'blur' },
        security_group_rule: { required: true, message: '安全组规则数量是必填的', type: 'number', trigger: 'blur' }
      }
    }
  },
  methods: {
    getNetworkQuota (project) {
      this.project = project
      this.networkQuotaModal = true
      this.networkQuotaLoading = true
      getPrivateCloudNetworkQuota(this.project.id).then(res => {
        this.networkQuotaLoading = false
        if (res.data.quota) {
          this.networkQuota = res.data.quota
          this.networkQuotaForm.floatingip = res.data.quota.floatingip.limit
          this.networkQuotaForm.network = res.data.quota.network.limit
          this.networkQuotaForm.subnet = res.data.quota.subnet.limit
          this.networkQuotaForm.port = res.data.quota.port.limit
          this.networkQuotaForm.router = res.data.quota.router.limit
          this.networkQuotaForm.security_group = res.data.quota.security_group.limit
          this.networkQuotaForm.security_group_rule = res.data.quota.security_group_rule.limit
          this.networkQuotaGetError = false
        } else {
          this.networkQuotaGetError = true
        }
      }).catch(res => {
        this.networkQuotaLoading = false
        this.networkQuotaGetError = true
        console.error(res.response)
      })
    },
    networkQuotaSubmit () {
      this.$refs.networkQuotaForm.validate((valid) => {
        if (valid) {
          this.networkQuotaSubmitting = true
          updatePrivateCloudNetworkQuota(this.networkQuotaForm, this.project.id).then(res => {
            this.networkQuotaSubmitting = false
            this.networkQuotaModal = false
            this.networkQuotaError = false
            this.networkQuotaErrorMsg = null
            this.$Notice.success({title: '操作成功'})
          }).catch(res => {
            this.networkQuotaSubmitting = false
            console.error(res.response)
            this.$Notice.error({title: '操作失败'})
            this.networkQuotaErrorMsg = res.response.data
            this.networkQuotaError = true
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
